import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import type { TextResponse } from '@core-api/presentation/types/response';
import { useAnimatedScroll } from '../utils/useAnimatedScroll';
import { ResponsesGrid } from './responses-grid';

export const BOTTOM_PADDING_VALUE = 200;

interface FlowingGridProps {
  showUpvotes: boolean;
  responses: TextResponse[];
  onItemClick: (index: number) => void;
  numberOfColumns: number;
  isResponsesHidden: boolean;
  shouldAnimate: boolean;
  isReadonly: boolean;
}

export const FlowingGrid = React.memo(
  ({
    showUpvotes,
    responses,
    onItemClick,
    numberOfColumns,
    isResponsesHidden,
    shouldAnimate,
    isReadonly,
  }: FlowingGridProps) => {
    const { containerRef, contentRef, handleScroll } = useAnimatedScroll();

    return (
      <Box width="100%" height="100%" data-testid="visualization-flowing-grid">
        <Box
          ref={containerRef}
          flex="auto"
          flexDirection="row"
          width="100%"
          height="100%"
          overflow="auto"
          onScroll={handleScroll}
        >
          <Box
            id="flow-wrapper"
            display="flex"
            width="100%"
            flexDirection="column"
            height="auto"
            ref={contentRef}
            pb={`${BOTTOM_PADDING_VALUE}px`}
          >
            <ResponsesGrid
              responses={responses}
              shouldSplitResponses={showUpvotes}
              onItemClick={onItemClick}
              numberOfColumns={numberOfColumns}
              isResponsesHidden={isResponsesHidden}
              shouldAnimate={shouldAnimate}
              isReadonly={isReadonly}
            />
          </Box>
        </Box>
      </Box>
    );
  },
);
